export default __webpack_public_path__ + "static/media/parallax-bg42.3ec04b6d.jpg";